<template>
  <div class="contact-data form-view split-view fill-height">
    <v-row class="split-view__row fill-height" no-gutters>
      <left-side-image />
      <v-col cols="12" md="7" class="split-view__panel">
        <div class="split-view__scroll">
        <nav-bar-page />

        <v-container>
          <v-row justify="center" class="mt-0">
            <v-col cols="12" class="mt-0 py-0">
              <v-stepper alt-labels elevation="0">
                <v-stepper-header>
                  <v-stepper-step step="" class="active-step today-medium">
                    Póliza
                  </v-stepper-step>

                  <v-divider inset class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Simulador
                  </v-stepper-step>

                  <v-divider class="active-separator-step"></v-divider>

                  <v-stepper-step step="" class="active-step today-medium">
                    Formulario
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Firma de documentos
                  </v-stepper-step>

                  <v-divider class="grey-separator-step"></v-divider>

                  <v-stepper-step step="" class="grey-step today-medium">
                    Pago
                  </v-stepper-step>
                </v-stepper-header>
              </v-stepper>
            </v-col>
            <v-col class="text-center justify-center d-flex d-sm-none">
              <div class="text-h6 today-medium primary--text">Formulario</div>
            </v-col>
          </v-row>

          <template v-if="!dataForm">
            <div class="d-flex justify-center mt-6">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
                aria-label="Cargando formulario"
              ></v-progress-circular>
            </div>
          </template>
          <template v-else>
            <v-row justify="center">
              <v-col cols="12" md="10" class="px-4">
                <p class="form-view__hint today-light">
                  Completa cada sección. Tus respuestas se guardan
                  automáticamente.
                </p>
                <Fields v-if="dataForm" :dataForm="dataForm"></Fields>
                <div class="form-view__actions">
                  <v-btn
                    block
                    :loading="loading"
                    :disabled="loading"
                    class="form-btn form-btn--primary today-medium"
                    elevation="0"
                    @click="goSignatureDocuments"
                  >
                    Continuar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-container>
        </div>
      </v-col>
    </v-row>

    <v-snackbar
      v-model="snackbar"
      :timeout="4000"
      bottom
      right
      role="status"
    >
      <div v-html="snackbarMessage"></div>
    </v-snackbar>
  </div>
</template>

<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import NavBarPage from "@/components/Layouts/NavBarPage";
import Fields from "@/components/Form/Fields";
import { api } from "@/helpers/axios";
import { constants } from "@/helpers/constants";
import { locals } from "@/helpers/locals";

export default {
  name: "Form",
  components: { LeftSideImage, NavBarPage, Fields },
  data() {
    return {
      payDialog: false,
      registerCellphoneDialog: false,
      loadingCellphone: false,
      loading: false,
      codeSent: false,
      firstFeeValue: 0,
      creditStudy: 15000,
      insurance: 2365,
      ivaValue: 2143,
      othersFeeValue: 0,
      amortizedFee: 0,
      admin: 10000,
      totalValuePolicy: 3500000,
      discountValue: 175716,
      valueFinance: 3324284,
      feeNumber: 2,
      rate: 1.25,
      feeValue: 0,
      expires_in: 60,
      countdown: "",
      dataForm: null,
      snackbar: false,
      snackbarMessage: "",
    };
  },
  mounted() {},
  methods: {
    goSignatureDocuments() {
      // CONSUMIR EL SERVICIO DE VALIDACION DE FORMULARIO
      this.loading = true;
      api
        .post(
          constants.endPoints.validateFullForm,
          {
            user_request_id: this.request.id,
          },
          true
        )
        .then((response) => {
          this.$router.push("/firma-documentos");
        })
        .catch(
          function (error) {
            try {
              let status = error.response.status;
              if (status == 401) {
                locals.clearLocal();
                this.$router.push("/");
              }
              let errors = error.response.data.errors;
              let message = "";
              for (var [key, value] of Object.entries(errors)) {
                message = message + value + "<br>";
              }
              this.snackbarMessage = message;
              this.snackbar = true;
              this.loading = false;
            } catch (e) {
              console.log(e);
              locals.clearLocal();
              this.$router.push("/");
            }
          }.bind(this)
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created: function () {
    this.request = locals.getLocal("request");
    api
      .post(
        constants.endPoints.form,
        {
          user_request_id: this.request?.id || 4003,
        },
        true
      )
      .then((response) => {
        this.dataForm = response.data.data.form.map((cat) => {
          return {
            ...cat,
            fields: cat.fields.map((field) => {
              if (field.type === "checkbox_options" && !field.value) {
                field.value = field.options
                  .map((option) => option.key)
                  .join(", ");
                api.post(
                  constants.endPoints.saveForm,
                  {
                    field_id: field.id,
                    user_request_id: this.request.id,
                    value: field.value,
                  },
                  true
                );
              }
              return {
                ...field,
                value:
                  field.type === "checkbox_options"
                    ? field.value.split(", ")
                    : field.value,
              };
            }),
          };
        });
      })
      .catch(
        function (error) {
          try {
            let status = error.response.status;
            if (status === 401) {
              locals.clearLocal();
              this.$router.push("/");
            }
            let errors = error.response.data.errors;
            let message = "";
            for (var [key, value] of Object.entries(errors)) {
              message = message + value + "<br>";
            }
            this.snackbarMessage = message;
            this.snackbar = true;
            this.loading = false;
          } catch (e) {
            console.log(e);
            locals.clearLocal();
            this.$router.push("/");
          }
        }.bind(this)
      );
  },
};
</script>

<style lang="scss">
.form-view {
  .form-view__hint {
    color: rgba(0, 0, 0, 0.64);
    font-size: 0.875rem;
    line-height: 1.45;
    margin: 4px 0 16px;
    text-wrap: pretty;
  }

  .form-view__actions {
    margin: 20px 0 28px;
  }
}

.form-btn {
  border-radius: 10px !important;
  font-size: 0.9375rem !important;
  height: 44px !important;
  letter-spacing: 0 !important;
  min-height: 44px;
  text-transform: none !important;
  touch-action: manipulation;
  transition-duration: 150ms;
  transition-property: transform, background-color, color, box-shadow, opacity;
  transition-timing-function: ease-out;
}

.form-btn:active:not(.v-btn--disabled) {
  transform: scale(0.96);
}

.form-btn--primary {
  background: #00205b !important;
  box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
  color: #ffffff !important;
}

.form-btn--primary:hover:not(.v-btn--disabled) {
  background: #001846 !important;
}

.form-btn.v-btn--disabled {
  opacity: 0.5;
}

.form-btn:focus-visible {
  outline: 2px solid #00205b;
  outline-offset: 3px;
}

@media (prefers-reduced-motion: reduce) {
  .form-btn {
    transition: none;
  }

  .form-btn:active:not(.v-btn--disabled) {
    transform: none;
  }
}

.v-stepper__label {
  font-size: 13px;
}

.active-step .v-stepper__label {
  color: #00205b !important;
}

.active-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
  background: #00205b !important;
}

.grey-step > span {
  min-width: 12px !important;
  height: 12px !important;
  width: 12px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin-top: 29px !important;
}

.active-separator-step {
  border-color: #00205b !important;
}

.grey-separator-step {
  border-color: rgba(0, 0, 0, 0.38) !important;
}

.v-divider {
  border-width: 1px 2px 2px !important;
}

.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 29px -82px 0 !important;
}

@media (max-width: 600px) {
  .v-stepper--alt-labels .v-stepper__step {
    flex-basis: 120px !important;
    padding: 5px !important;
  }

  .v-divider {
    visibility: hidden;
  }
}
</style>
